<div class="table-responsive gung-responsive w-100">
  <table class="table table-borderless table-striped table-hover">
    <thead>
      <tr>
        <th scope="col" translate>#</th>
        <th scope="col" translate>ORDER_ID</th>
        <th scope="col" translate>PRODUCT_ID</th>
        <th scope="col" translate>DESCRIPTION</th>
        <th scope="col" translate class="text-center">QUANTITY</th>
        <th scope="col" translate>ORDER_STATUS</th>
        @if (isSales) {
          <th scope="col" translate>CUSTOMER</th>
        }
        <th scope="col" translate>ORDER_DATE</th>
        <th scope="col" translate>ESTIMATED_DELIVERY_DATE</th>
        <th scope="col" translate>TOTAL</th>
        <th scope="col" translate></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let order of data">
        <tr>
          <td [attr.data-label]="'#'">
            {{order.rowNumber }}
          </td>
          <td [attr.data-label]="'ORDER_ID' | translate">
            <a [routerLink]="['/orders', order.id]">
              {{ order?.row?.extra?.gme?.displayId || order.id }}
            </a>
          </td>
          <td [attr.data-label]="'PRODUCT_ID' | translate">
            {{ order.row?.productId }}
          </td>
          <td [attr.data-label]="'DESCRIPTION' | translate">
            {{ order.row?.name }}
          </td>
          <td [attr.data-label]="'QUANTITY' | translate" class="text-center">
            {{ order.row?.extra?.gme?.quantity || order.row?.quantity }}
          </td>
          <td [attr.data-label]="'ORDER_STATUS' | translate">
            <span translate>{{ order.row?.extra?.gme?.status }}</span>
          </td>
          @if (isSales) {
            <td [attr.data-label]="'CUSTOMER' | translate">
              {{ (order.extra.gme?.customerId  || '-') + ' - ' + (order.extra.gme?.customerName || '-') }}
            </td>
          }
          <td [attr.data-label]="'ORDER_DATE' | translate">
            <span *ngIf="order.extra.gme?.orderDate">
              {{ order.extra.gme?.orderDate | date: dateUtilService.dateFormat }}
            </span>
          </td>
          <td [attr.data-label]="'ESTIMATED_DELIVERY_DATE' | translate">
            <span *ngIf="order?.extra?.gme?.deliveryDate">
              {{ order.extra.gme?.deliveryDate | date: dateUtilService.dateFormat }}
            </span>
          </td>
          <td [attr.data-label]="'TOTAL' | translate">
            <lib-price [price]="order?.row.extra.gme.totalGrossPrice || 0" class="form-control-plaintext p-0"></lib-price>
          </td>
          <td>
            <a href="{{ baseUrl + 'download/order-pdf/' + order.id }}" download="{{ order.id + '.pdf' }}"
              (click)="$event.stopPropagation()"><i class="far fa-file-pdf"></i>
            </a>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>